import { render, staticRenderFns } from "./medicineSchoolAdd.vue?vue&type=template&id=8ce299cc&scoped=true"
import script from "./medicineSchoolAdd.vue?vue&type=script&lang=js"
export * from "./medicineSchoolAdd.vue?vue&type=script&lang=js"
import style0 from "./medicineSchoolAdd.vue?vue&type=style&index=0&id=8ce299cc&prod&lang=less&scoped=true"
import style1 from "./medicineSchoolAdd.vue?vue&type=style&index=1&id=8ce299cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce299cc",
  null
  
)

export default component.exports